export default {
      id: "h-01-usage",
      viewBox: "0 0 265 279",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#h-01",
      toString: function () {
        return this.url;
      }
    }